import { render, staticRenderFns } from "./newZhe.vue?vue&type=template&id=7d3dc0a7&scoped=true&"
import script from "./newZhe.vue?vue&type=script&lang=js&"
export * from "./newZhe.vue?vue&type=script&lang=js&"
import style0 from "./newZhe.vue?vue&type=style&index=0&id=7d3dc0a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3dc0a7",
  null
  
)

export default component.exports